import React from "react";
import './styles/CustomSweetAlert.css';
import SweetAlert from "react-bootstrap-sweetalert";

const CustomSweetAlert = (props) => {
    const {
        show, title, titleSize, text, showConfirm, showCancel, btnSize, confirmBtnText, cancelBtnText,
        cancelBtnBsStyle, onConfirm, onCancel
    } = props;
    return (
        <div className={"custom-sweet-alert"}>
            <SweetAlert
                show={show}
                title={title ? title : ""}
                titleSize={titleSize}
                showConfirm={showConfirm}
                showCancel={showCancel}
                confirmBtnText={confirmBtnText}
                cancelBtnText={cancelBtnText}
                cancelBtnBsStyle={cancelBtnBsStyle ? cancelBtnBsStyle : "danger"}
                btnSize={btnSize ? btnSize : "sm"}
                onConfirm={onConfirm ? onConfirm : () => { }}
                onCancel={onCancel}
                openAnim={{ name: 'showSweetAlert', duration: 500 }}
            >
                {text}
            </SweetAlert>
        </div>
    )
};

export default CustomSweetAlert;